import { defineStore } from "pinia";
import { getMollieSellerStatus } from "@/api/mollie";

export const useMollieStore = defineStore("mollie", {
  state: () => ({
    sellerStatus: null,
    loading: false,
    error: null,
  }),
  getters: {
    isConnected: state => state.sellerStatus?.connected || false,
    canReceivePayments: state => state.sellerStatus?.canReceivePayments || false,
    oauthUrl: state => state.sellerStatus?.oauthUrl || null,
    statusMessage: state => state.sellerStatus?.statusMessage || "",
    mollieId: state => state.sellerStatus?.mollieId || null,
    connectionDate: state => state.sellerStatus?.connectionDate || null,
    company: state => state.sellerStatus?.company || "",
  },
  actions: {
    async fetchSellerStatus() {
      this.loading = true;
      this.error = null;
      try {
        const response = await getMollieSellerStatus();
        this.sellerStatus = response.data;
      } catch (error) {
        this.error = "Erreur lors du chargement du statut Mollie";
        console.error("Mollie status error:", error);
      } finally {
        this.loading = false;
      }
    },
    resetStatus() {
      this.sellerStatus = null;
      this.error = null;
    },
  },
  // Pas de persistance pour les données sensibles
  persist: false,
});
